import styled from 'styled-components';
export const Container = styled.div.withConfig({
  displayName: "Playbooksstyle__Container",
  componentId: "sc-133b69a-0"
})(["padding:10px;"]);